'use strict';

module.exports = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/var/getOwnPropertySymbols.js
// module id = 844
// module chunks = 0